import { createAction } from '@reduxjs/toolkit'
import { Order } from '../../../types/api'

/**
 * Actions do módulo Orders
 */
export const ordersActions = {
  // Fetch orders list
  fetchOrdersRequest: createAction<{ status?: string; page?: number; limit?: number } | undefined>('orders/fetchOrdersRequest'),
  fetchOrdersSuccess: createAction<{ orders: Order[]; pagination: any }>('orders/fetchOrdersSuccess'),
  fetchOrdersFailure: createAction<{ error: string }>('orders/fetchOrdersFailure'),
  
  // Update filters
  updateFilters: createAction<{ status?: string; page?: number; limit?: number }>('orders/updateFilters'),
  
  // Fetch order by ID
  fetchOrderRequest: createAction<string>('orders/fetchOrderRequest'),
  fetchOrderSuccess: createAction<{ order: Order }>('orders/fetchOrderSuccess'),
  fetchOrderFailure: createAction<{ error: string }>('orders/fetchOrderFailure'),
  
  // Cancel order
  cancelOrderRequest: createAction<string>('orders/cancelOrderRequest'),
  cancelOrderSuccess: createAction<{ order: Order }>('orders/cancelOrderSuccess'),
  cancelOrderFailure: createAction<{ error: string }>('orders/cancelOrderFailure'),
  
  // Clear order cache
  clearOrderCache: createAction('orders/clearOrderCache'),
  
  // Clear errors
  clearListError: createAction('orders/clearListError'),
  clearOrderError: createAction('orders/clearOrderError'),
}

